<template>
  <div>
    <b-modal
      class="modal-form-work-plan"
      id="modal-form-work-plan"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      centered
      size="l"
      :title="text"
    >
      <div class="mb-4">
        <label for="input-1">Name Plan :</label>
        <b-form-input
          id="input-1"
          v-model="form.title"
          placeholder="Enter name plan"
          required
        ></b-form-input>
      </div>
      <div class="mb-4">
        <label for="input-3">Target :</label>
        <b-form-input
          id="input-3"
          v-model="form.target"
          placeholder="Enter target plan"
          required
        ></b-form-input>
      </div>
      <div  class="mb-4">
        <label>Budget :</label>
        <validation-provider
          name="Budget"
          rules="required|min_value:0"
          v-slot="{ errors }"
        >
          <b-form-group :invalid-feedback="errors[0]">
            <b-input-group prepend="Rp" :class="{ 'is-invalid': errors.length }">
              <money
                class="form-control"
                v-model="form.budget"
                placeholder="0"
              />
            </b-input-group>
          </b-form-group>
        </validation-provider>
      </div>
      <div class="mb-4">
        <label for="input-4">Day Length :</label>
        <b-form-input
          id="input-4"
          v-model="form.dayLength"
          placeholder="Enter day length"
          :style="{ borderColor: hasAlphabetInput ? 'red' : '' }"
          @input="onInputChange"
        ></b-form-input>
      </div>
      <div class="d-flex mb-4">
        <div class="date-picker">
          <label for="input-5">Start Date :</label>
          <b-form-datepicker
            id="input-5"
            v-model="form.firstDate"
            placeholder="Enter date"
          ></b-form-datepicker>
        </div>
        <div class="ml-3">
          <label>Start Time :</label>
          <b-form-timepicker v-model="form.startTime" locale="en"></b-form-timepicker>
        </div>
      </div>
      <div class="d-flex mb-4">
        <div class="date-picker">
          <label for="input-6">End Date :</label>
          <b-form-datepicker
            id="input-6"
            v-model="form.endDate"
            placeholder="Enter end date plan"
            :state="isEndDateValid ? null : false"
          ></b-form-datepicker>
        </div>
        <div class="ml-3">
          <label>End Time :</label>
          <b-form-timepicker v-model="form.endTime" locale="en"></b-form-timepicker>
        </div>
      </div>
      <p v-if="!isEndDateValid" class="text-danger">End Date must be greater than or equal to Start Date.</p>
      <div class="d-flex flex-column mb-4">
        <label>Status :</label>
        <b-form-select
          v-model="form.workPlanStatusId"
          :options="modeUpdate ? workPlanStatusOptions : filteredWorkPlanStatusOptions"
        />
      </div>
      <div class="d-flex flex-column mb-4">
        <label class="mb-1">Comment :</label>
        <b-form-textarea
          rows="3"
          no-resize
          :readonly="!modeUpdate"
          v-model="form.descStatus"
          :placeholder="modeUpdate ? '' : '-'"
        ></b-form-textarea>
      </div>
      <div class="mt-3 d-flex justify-content-center">
        <b-button
          class="text-white"
          variant="warning"
          type="submit"
          block
          @click="submitForm"
        >
          {{ variantForm }}
          <b-spinner
            v-if="isBusy"
            class="ml-1"
            label="Spinning"
            small
          />
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from '@/api'

export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    modeUpdate: {
      type: Boolean,
      default: false
    },
    dataUpdate: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      item: [],
      form: {
        title: '',
        target: '',
        budget: 0,
        firstDate: '',
        startTime: '',
        endDate: '',
        endTime: '',
        dayLength: 0,
        workPlanStatusId: '',
        descStatus: ''
      },
      workPlanStatusOptions: [],
      filteredWorkPlanStatusOptions: [],
      selectedStatusLabel: '',
      isBusy: false,
      hasAlphabetInput: false,
      messageRequest: {
        text: '',
        variantAlert: ''
      }
    }
  },
  computed: {
    variantForm() {
      return this.modeUpdate ? 'Update' : 'Create'
    },
    isEndDateValid() {
      if (this.form.startDate && this.form.endDate) {
        return new Date(this.form.endDate) >= new Date(this.form.startDate)
      }
      return true
    }
  },
  created() {
    this.getStatus()
  },
  methods: {
    onInputChange() {
      const regex = /^[0-9]+$/
      this.hasAlphabetInput = !regex.test(this.form.budget)
    },
    async submitForm() {
      const hasNullValue = Object.keys(this.form).some(key => key !== 'descStatus' && this.form[key] === '')
      const isEndDateValid = new Date(this.form.endDate) >= new Date(this.form.firstDate)
      if (hasNullValue) {
        this.isBusy = false
        this.$nextTick(() => {
          this.$bvToast.toast('Please fill all form fields', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      } else if (!isEndDateValid) {
        this.isBusy = false
        this.$nextTick(() => {
          this.$bvToast.toast('Please ensure that the End Date is valid', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      } else {
        const startDate = this.form.firstDate.concat(' ', this.form.startTime)
        const endDate = this.form.endDate.concat(' ', this.form.endTime)
        if (this.modeUpdate) {
          try {
            this.isBusy = true
            await api.workPlan.updatePlan(this.form.id, {
              title: this.form.title,
              target: this.form.target,
              budget: this.form.budget,
              firstDate: startDate,
              endDate: endDate,
              dayLength: this.form.dayLength,
              workPlanStatusId: this.form.workPlanStatusId,
              descStatus: this.form.descStatus
            })
            this.$bvModal.hide('modal-form-work-plan')
            this.isBusy = false
            this.form = {
              title: '',
              target: '',
              budget: 0,
              firstDate: '',
              startTime: '',
              endDate: '',
              endTime: '',
              dayLength: 0,
              workPlanStatusId: '',
              descStatus: ''
            }
            setTimeout(() => {
              this.$emit('refresh')
            }, 2000)
            this.sendResultToParent('Update work plan success', 'success')
          } catch (error) {
            console.log(error)
          }
        } else {
          if (!this.form.workPlanStatusId) {
            this.$bvToast.toast('Please select a status', {
              headerClass: 'd-none',
              solid: true,
              variant: 'danger'
            })
          }
          this.filteredWorkPlanStatusOptions.forEach(item => {
            if (item.text === this.form.workPlanStatusId) {
              this.form.workPlanStatusId = item.value
            }
          })
          try {
            this.isBusy = true
            await api.workPlan.post({
              title: this.form.title,
              target: this.form.target,
              budget: this.form.budget,
              firstDate: startDate,
              endDate: endDate,
              dayLength: this.form.dayLength,
              workPlanStatusId: this.form.workPlanStatusId,
              descStatus: this.form.descStatus
            })
            this.$bvModal.hide('modal-form-work-plan')
            this.isBusy = false
            this.form = {
              title: '',
              target: '',
              budget: 0,
              firstDate: '',
              startTime: '',
              endDate: '',
              endTime: '',
              dayLength: 0,
              workPlanStatusId: '',
              descStatus: ''
            }
            setTimeout(() => {
              this.$emit('refresh')
            }, 2000)
            this.sendResultToParent('Create new work plan success', 'success')
          } catch (error) {
            console.log(error)
          }
        }
      }
    },
    sendResultToParent(message, variant) {
      this.messageRequest.text = message
      this.messageRequest.variantAlert = variant
      this.$emit('result-request', this.messageRequest)
    },
    seperateDateTime() {
      const [startDate, startTime] = this.dataUpdate.firstDate.split(' ')
      const [endDate, endTime] = this.dataUpdate.endDate.split(' ')
      this.form.firstDate = startDate
      this.form.startTime = startTime
      this.form.endDate = endDate
      this.form.endTime = endTime
    },
    async getStatus() {
      try {
        const { data } = await api.workPlan.getListPlanStatus()
        this.workPlanStatusOptions = data.data.map(item => ({
          value: item.id,
          text: item.name
        }))
        if (!this.modeUpdate) {
          this.filteredWorkPlanStatusOptions = this.workPlanStatusOptions.filter(item =>
            item.text === 'On Going' || item.text === 'In Progress'
          )
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  watch: {
    dataUpdate: {
      handler(oldValue) {
        this.form = { ...oldValue }
        this.seperateDateTime()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-new-work-plan #input-1, #input-2, #input-3, #input-4, #input-5, #input-6{
padding: 10px;
}

.date-picker{
  width: 35vh;
}

.time-picker{
  margin-left: 10px;
}
</style>
